// extracted by css-extract-rspack-plugin
export default {"leadSmall":"lead-small--t1uAkBpmpEkRpV3C","lead":"lead--AQWF2WnhgyIZcJQI"};